import { Spinner } from '@chakra-ui/react';
import { useState } from 'react';

import { apiSensedia } from '../../../../../services/api-sensedia';
import { DataTableOffersType } from '../types/MovimentacaoFundosType';

export const OfferRow = ({
  row,
  index,
  handleSelectOffers
}: {
  row: DataTableOffersType;
  index: number;
  handleSelectOffers: (row: DataTableOffersType, consentStatus: string) => void;
}) => {
  let apiMf = apiSensedia;

  if (process.env.NODE_ENV != 'development') {
    apiMf = apiSensedia;
  }

  const [isLoadingClick, setLoadingClick] = useState(false);

  return (
    <tr key={index} className="tw-text-sm">
      <td className="tw-text-blue-900 tw-px-4 tw-py-3 tw-border-solid tw-border-b-8 tw-border-b-white tw-bg-gray-100 tw-border-l-4 tw-border-l-teal-400">
        <span>{row.nome_cliente}</span>
      </td>
      <td className="tw-text-blue-900 tw-px-4 tw-py-3 tw-border-solid tw-border-b-8 tw-border-b-white tw-bg-gray-100">
        <span>{row.cpf}</span>
      </td>
      <td className="tw-text-blue-900 tw-px-4 tw-py-3 tw-border-solid tw-border-b-8 tw-border-b-white tw-bg-gray-100">
        <span>{row.numero_proposta}</span>
      </td>
      <td className="tw-text-blue-900 tw-px-4 tw-py-3 tw-border-solid tw-border-b-8 tw-border-b-white tw-bg-gray-100">
        <span>{row.nome_produto}</span>
      </td>
      <td className="tw-text-blue-900 tw-text-right tw-px-4 tw-py-3 tw-border-solid tw-border-b-8 tw-border-b-white tw-bg-gray-100">
        <button
          data-testid={`select-button-${index}`}
          id={`btn-${row.numero_proposta}`}
          name={row.nome_cliente}
          className=" tw-w-40 tw-bg-[#FA6B25] tw-text-white tw-font-bold tw-py-3 tw-px-4 tw-focus:outline-none tw-focus:shadow-outline  tw-rounded-md"
          onClick={async (e: any) => {
            const numeroProposta = Number(e.target.id.replace('btn-', ''));
            console.log('numero proposta', numeroProposta);
            setLoadingClick(true);

            let looping = true;
            while (looping) {
              try {
                const response = await apiMf.get(
                  '/movimentacoes-fundos/consentimentos/status',
                  {
                    headers: {
                      cpf: row.cpf
                    }
                  }
                );

                console.log('resposta consentimento', response.data);
                console.log('linha escolhida', row);

                handleSelectOffers(row, response.data?.status);

                looping = false;
              } catch (e: any) {
                console.log('erro aqui', e);
                if (e.response.status == 500) {
                  console.log(
                    'ocorreu internal server error',
                    e.response.statusText
                  );
                  console.log('ocorreu internal server error', e.response.data);
                } else if (e.response.status == 504) {
                  console.log('ocorreu gateway timeout', e.response.data);
                }
                if (e.response.status != 504) {
                  looping = false;
                }
              }
            }

            setLoadingClick(false);
          }}
        >
          {isLoadingClick ? (
            <Spinner size="sm" color="#ffffff" />
          ) : (
            'Selecionar'
          )}
        </button>
      </td>
    </tr>
  );
};
